import { useState, useEffect, useRef } from "react";

export const useDebounce = <T>(value: T, delay: number): { debouncedValue: T, isDebouncing: boolean } => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const [isDebouncing, setIsDebouncing] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      setIsDebouncing(false);
    }

    setIsDebouncing(true);

    timeoutRef.current = setTimeout(() => {
      setDebouncedValue(value);
      setIsDebouncing(false);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        setIsDebouncing(false);
      }
    };
  }, [value, delay]);

  return { debouncedValue, isDebouncing };
};
